import { FC } from 'react';
import cn from 'classnames';

import { AuthInteractions } from 'features/AuthInteractions';

import styles from './styles.module.scss';

import type { ITopBarInteraction } from '../config/declarations';

const TopBarInteraction: FC<ITopBarInteraction> = ({ auth, isSimplifiedHeader }) => {
  if (!auth) {
    return null;
  }

  return (
    <div className={cn(styles.interaction, { [styles.simplified]: isSimplifiedHeader })}>
      <AuthInteractions auth={auth} />
    </div>
  );
};

export default TopBarInteraction;
